import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../contexts/UserContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { providersPathTo } from '../utils/Api';
import SnackbarContext from '../contexts/SnackbarContext';
import TagList from './TagList';
import { Avatar, Box, Button, Divider, Typography } from '@mui/material';
import ProductPhotoPlaceholder from '../images/placeholder_product_image.png';
import { apiBaseUrl } from '../utils/Api/Api';
import ProviderCard from './building_blocks/ProviderCard';
import { currency } from './building_blocks/Currency';
import { ShoppingCartProductsContext } from '../contexts/ShoppingCartProductsContext';


function ProviderShop() {
  const location = useLocation();
  const provider = location.state;
  const navigate = useNavigate();

  const { openSnackbar } = useContext(SnackbarContext);
  
  if (!provider) {
    return <div>Carregando...</div>;
  }

  return (
    <Box>
      {provider.business_banner && 
        <Box sx={{width: "100%", height: "140px"}}>
          <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={`${apiBaseUrl}${provider.business_banner}`} />
        </Box>
      }
      <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
        <Box flexGrow={1} m={2} textAlign="left">
            <Typography variant="body1"><b>{provider.name}</b></Typography>
            {/* <Typography fontSize={14} color="gray">
                <small>Pet Shop &#9679; 3,2km</small>
            </Typography> */}
            <Typography fontSize={14} color="gray">
                <small>Entrega em até 24h &#9679; R$10,00</small>
            </Typography>
            <Typography color="primary" onClick={() => navigate('/provider/' + provider.id)} fontSize={14}><small>Voltar para loja</small></Typography>
        </Box>
        <Box mr={2}>
          <Avatar sx={{border: '1px solid lightgray', marginLeft: 'auto', width: '60px', height: '60px'}} src={provider.business_logo && 'http://localhost:3000' + provider.business_logo} />
        </Box>
      </Box>
      <Divider><Typography color="primary"><b>Informações</b></Typography></Divider>
      <Box>
        <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginLeft: '20px', height: '35px'}}>
            <Box>
                <Typography mt={3} mb={2} textAlign="left" variant="body2"><b>Endereço</b></Typography>
            </Box>
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginLeft: '20px'}}>
            <Box>
                <Typography mt={2} textAlign="left" variant="body2">{provider.address.logradouro}, {provider.address.numero} - {provider.address.bairro}</Typography>
                <Typography textAlign="left" variant="body2">{provider.address.cep}</Typography>
                <Typography textAlign="left" variant="body2">{provider.address.localidade} - {provider.address.uf}</Typography>
            </Box>
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginLeft: '20px'}}>
            <Box>
                <Typography mt={3} mb={2} textAlign="left" variant="body2"><b>Contato</b></Typography>
            </Box>
        </Box>
        <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginLeft: '20px'}}>
            <Box>
                <Typography textAlign="left" variant="body2">{provider.phone}</Typography>
            </Box>
        </Box>
      </Box>

    </Box>
  );
}

export default ProviderShop

